'use strict';

// DATA TYPES //

var DTYPES = [
	'int8',
	'uint8',
	'uint8_clamped',
	'int16',
	'uint16',
	'int32',
	'uint32',
	'float32',
	'float64'
];


// EXPORTS //

module.exports = DTYPES;



//////////////////
// WEBPACK FOOTER
// ./~/dstructs-matrix/lib/dtypes.js
// module id = 616
// module chunks = 0